/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/priceAndAvailabilityMappers";
import * as Parameters from "../models/parameters";
/** Class representing a PriceAndAvailability. */
var PriceAndAvailability = /** @class */function () {
  /**
   * Create a PriceAndAvailability.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function PriceAndAvailability(client) {
    this.client = client;
  }
  PriceAndAvailability.prototype.get = function (options, callback) {
    return this.client.sendOperationRequest({
      options: options
    }, getOperationSpec, callback);
  };
  return PriceAndAvailability;
}();
export { PriceAndAvailability };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getOperationSpec = {
  httpMethod: "GET",
  path: "api/subscriptions/{subscriptionId}/priceAndAvailability/virtualMachines",
  urlParameters: [Parameters.subscriptionId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.VirtualMachinePriceAndAvailabilityData
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};